import { c as _c } from "react/compiler-runtime";
import { getOrgWebhookPortalOptions } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request';
import { Divider } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { cx } from 'class-variance-authority';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import SectionHeader from '@/components/section-header';
import Content from './components/content';
import ErrorComponent from './components/error';
import IpAllowlist from './components/ip-allowlist';
import Loading from './components/loading';
import useFakeSpinnerTimeout from './use-fake-spinner-timeout';
const Webhooks = () => {
  const $ = _c(43);
  const {
    t
  } = useTranslation("webhooks");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgWebhookPortalOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    error,
    isPending
  } = useQuery(t0);
  const showSpinner = useFakeSpinnerTimeout();
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Head><title>{t1}</title></Head>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <header className="hidden md:flex items-center justify-between mb-6"><h2 className="text-heading-2">{t3}</h2></header>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp4);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IpAllowlist />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6) {
    t8 = <SectionHeader title={t5} subtitle={t6}>{t7}</SectionHeader>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Divider className="mb-4" />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = !showSpinner;
  let t11;
  if ($[18] !== showSpinner || $[19] !== t10) {
    t11 = cx({
      hidden: showSpinner,
      block: t10
    });
    $[18] = showSpinner;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== data) {
    t12 = data && <Content data={data} />;
    $[21] = data;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== error) {
    t13 = error && <ErrorComponent message={getErrorMessage(error)} />;
    $[23] = error;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isPending) {
    t14 = isPending && <Loading />;
    $[25] = isPending;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t14) {
    t15 = <div className={t11}>{t12}{t13}{t14}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== showSpinner) {
    t16 = showSpinner && <Loading />;
    $[32] = showSpinner;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== isPending || $[35] !== t15 || $[36] !== t16) {
    t17 = <div aria-busy={isPending}>{t15}{t16}</div>;
    $[34] = isPending;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17 || $[39] !== t2 || $[40] !== t4 || $[41] !== t8) {
    t18 = <>{t2}{t4}{t8}{t9}{t17}</>;
    $[38] = t17;
    $[39] = t2;
    $[40] = t4;
    $[41] = t8;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};
export default Webhooks;
function _temp($) {
  return $.pageTitle;
}
function _temp2($_0) {
  return $_0.metaTitle;
}
function _temp3($_1) {
  return $_1.header.title;
}
function _temp4($_2) {
  return $_2.header.subtitle;
}